import { Badge, Card, ListGroup } from "react-bootstrap"
import { getUserById } from "../../services/usersService";
import { getDateLightFromTimestamp } from "../../services/utilities";
import { config } from "../../config";

const CardVisite = ({ visite }) => {

    const { date_create, date_visite, date_update, scelle, user_uid, type_visite, cles, cles_calcul } = visite;
    const visiteType = config.visits_types.find(item => item.id === type_visite).name;
    
    // Harmonisation du calcul des clés avec la liste des visites :
    // - si une "clé estimée" a été saisie et est > 0, on l'utilise
    // - sinon on bascule sur la "clé calculée"
    // On force la conversion en nombre pour éviter le cas où `cles` vaut "0" (string)
    // et serait considéré comme truthy, ce qui afficherait 0 au lieu de la valeur calculée.
    const clesEstimees = Number(cles);
    const clesCalculees = Number(cles_calcul);
    const clesAffichees = clesEstimees > 0 ? clesEstimees : (clesCalculees || 0);
    const isInsolite = visite.type_bien === 'inso';

    return(
        <Card>
            <Card.Header>
                <Card.Title className="mb-0">{visiteType} du {getDateLightFromTimestamp(date_visite)}</Card.Title>
            </Card.Header>
            <ListGroup variant="flush">
                <ListGroup.Item>
                    <>
                        <p className="mb-0">
                            Créée le {getDateLightFromTimestamp(date_create)} <span className="text-nowrap">par {visite.user_firstname} {visite.user_lastname}</span>
                        </p>
                        Modifiée le {getDateLightFromTimestamp(date_update)}
                        {scelle && <p className="mb-0">
                            Scellée le {getDateLightFromTimestamp(scelle)}
                        </p>}
                    </>
                </ListGroup.Item>
                {!isInsolite && <>
                    <ListGroup.Item>
                        <div className="d-flex align-items-center gap-2">
                            <h4 className="mb-0">
                                <Badge bg="success" pill><i className="icon icon-cle"></i> {clesAffichees}</Badge>
                            </h4>
                            <div>Clé estimée / affichée</div>
                        </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <div className="d-flex align-items-center gap-2">
                            <h4 className="mb-0">
                                <Badge bg="info" pill><i className="icon icon-cle"></i> {clesCalculees}</Badge>
                            </h4>
                            <div>Clé calculée</div>
                        </div>
                    </ListGroup.Item>
                </>}
            </ListGroup>
        </Card>
    );
}

export default CardVisite;
